var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.isActive)?_c('ActivityList',{key:_vm.card.id,attrs:{"filter":"filter","object-id":_vm.card.id,"object-type":"deck_card","type":"deck"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }